import { useEffect } from "react";

const attachScrollToTopHandler = (layoutBody: Element) => {
  const button = layoutBody.querySelector<HTMLButtonElement>(".scroll-to-top button");
  const scrollView = layoutBody.querySelector<HTMLElement>(".scrollbar-view");

  if (!button || !scrollView || button.dataset.scrollToTopFixed === "true") {
    return;
  }

  button.dataset.scrollToTopFixed = "true";

  button.addEventListener(
    "click",
    (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      layoutBody.querySelectorAll(".is-scrolling-to-top").forEach((node) => {
        node.classList.remove("is-scrolling-to-top");
      });
      scrollView.scrollTo({ top: 0, behavior: "smooth" });
    },
    true
  );
};

export const useApplicationLayoutScrollToTop = (isLayoutReady: boolean) => {
  useEffect(() => {
    if (!isLayoutReady) {
      return;
    }

    const layoutBody = document.querySelector(".ApplicationLayoutBody");
    if (layoutBody) {
      attachScrollToTopHandler(layoutBody);
    }

    const observer = new MutationObserver(() => {
      const body = document.querySelector(".ApplicationLayoutBody");
      if (body) {
        attachScrollToTopHandler(body);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [isLayoutReady]);
};
